/**
 * Self-hosted vendor CSS + globals previously loaded from CDNs in index.html.
 * Webpack bundles CSS into static/css/main.[hash].css; scripts attach to window for legacy usage.
 */

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'aos/dist/aos.css';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import 'leaflet/dist/leaflet.css';

import './vendor/jqueryGlobal';
import 'select2';
import 'datatables.net-dt';

import * as bootstrap from 'bootstrap';
import feather from 'feather-icons';
import AOS from 'aos';
import Chart from 'chart.js/auto';
import * as echarts from 'echarts';
import L from 'leaflet';
import * as d3 from 'd3';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

window.bootstrap = bootstrap;
window.feather = feather;
window.AOS = AOS;
window.Chart = Chart;
window.echarts = echarts;
window.L = L;
window.d3 = d3;
window.jspdf = { jsPDF };
